import { createAsyncReducer, createReducerFromMap } from "@coverme/redux";

const initialState = {
    isLoading: false,
    isInitialized: false,
    data: {},
};

export const searchMetadataReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_ENCOUNTER_SEARCH_METADATA", (state, action) => {
        return {
            users: action.value.users,
            facilities: action.value.facilities,
            programs: action.value.programs.map(x => {
                if (x.label === "CHIP Child") {
                    return {
                        label: "CHIP",
                        value: x.value,
                    };
                } else {
                    return x;
                }
            }),
        };
    }),
});

export default searchMetadataReducer;
